import { Link, useLocation } from 'react-router-dom';
import { categories } from '@/mocks/categories';
import { articles } from '@/mocks/articles';

interface BreadcrumbItem {
  label: string;
  path?: string;
}

export default function Breadcrumb() {
  const location = useLocation();
  const pathSegments = location.pathname.split('/').filter(Boolean);

  const items: BreadcrumbItem[] = [{ label: '首页', path: '/' }];

  if (pathSegments[0] === 'category' && pathSegments[1]) {
    const cat = categories.find((c) => c.id === pathSegments[1]);
    items.push({
      label: cat ? cat.name : '分类',
      path: `/category/${pathSegments[1]}`,
    });
  }

  if (pathSegments[0] === 'article' && pathSegments[1]) {
    const article = articles.find((a) => a.slug === pathSegments[1]);
    if (article) {
      const cat = categories.find((c) => c.id === article.categoryId);
      items.push({
        label: cat ? cat.name : '分类',
        path: `/category/${article.categoryId}`,
      });
    }
    items.push({
      label: article ? article.title : '文章',
    });
  }

  if (pathSegments[0] === 'about') {
    items.push({ label: '关于我们' });
  }

  if (pathSegments[0] === 'article' && !pathSegments[1]) {
    items.push({ label: '文章' });
  }

  if (items.length <= 1) return null;

  return (
    <nav aria-label="面包屑导航" className="px-4 md:px-6 py-3">
      <ol className="flex items-center flex-wrap gap-1 text-sm">
        {items.map((item, index) => (
          <li key={index} className="flex items-center gap-1">
            {index > 0 && (
              <i className="ri-arrow-right-s-line text-foreground-400 text-xs"></i>
            )}
            {item.path && index < items.length - 1 ? (
              <Link
                to={item.path}
                className="text-foreground-500 hover:text-primary-600 transition-colors"
              >
                {item.label}
              </Link>
            ) : (
              <span className={index === items.length - 1 ? 'text-foreground-900 font-medium' : 'text-foreground-500'}>
                {item.label}
              </span>
            )}
          </li>
        ))}
      </ol>
    </nav>
  );
}